var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTymeplushrmobileheader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 46,
    viewBox: "0 0 64 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63078 19.5835C5.91266 13.3167 10.5573 8.20101 16.5429 5.36172C22.5286 2.52243 29.3649 2.19216 35.548 4.44357C40.8697 6.38132 45.6176 10.9406 48.4328 15.411C45.7291 9.62427 40.3459 3.91881 33.9105 1.57552C28.659 -0.336167 22.9106 -0.414283 17.5787 1.35358C12.2467 3.12145 7.63704 6.63389 4.48208 11.3328C1.32713 16.0318 -0.192143 21.6477 0.165657 27.2882C0.523459 32.9288 2.73781 38.2705 6.45688 42.4646C4.20414 39.1741 2.77156 35.3782 2.27975 31.3963C1.78793 27.4144 2.25128 23.3631 3.63078 19.5835Z",
    fill: "#EE2738"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8699 12.1914L23.6293 27.806L22.5391 26.6288L38.8699 12.1914Z",
    fill: "#2D53DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6953 19.2578L24.2051 26.0913L23.1271 27.2802L15.6953 19.2578Z",
    fill: "#2D53DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTymeplushrmobileheader);
export default __webpack_public_path__ + "static/media/tymeplushrmobileheader.22796e2277e3b81e64e56bb16fbb79cc.svg";
export { ForwardRef as ReactComponent };